export const portfolioItems = [
  {
    id: 1,
    category: ["featured", "webApp"],
    title: "Superhero Sighting Web App",
    tech: "Java + Spring Boot + Thymeleaf + SQL",
    img: "assets/super_sighting_thumb.jpg",
  },
  {
    id: 2,
    category: ["featured", "website"],
    title: "NuCamp Website",
    tech: "HTML + CSS + SCSS + jQuery + JavaScript + Bootstrap + React",
    img: "assets/NuCampThumbnail.jpg",
  },
  {
    id: 3,
    category: ["website"],
    title: "Farview Farms Website",
    tech: "HTML + GoLive",
    img: "assets/farview_farms_preview.jpg",
  },
  {
    id: 4,
    category: ["mobileApp"],
    title: "NuCamp Mobile App",
    tech: "React Native + Expo + Json Server",
    img: "assets/nucamp_mobile.jpg",
  },
  {
    id: 5,
    category: ["featured", "mobileApp"],
    title: "The Dad App",
    tech: "React Native + Expo",
    img: "assets/dad_app_thumb.jpg",
  },
  {
    id: 6,
    category: ["otherThing"],
    title: "My Old Motorcycle, Sadly Missed",
    tech: "2011 Husqvarna TE250",
    img: "assets/steve_on_motorcycle.jpg",
  },
  {
    id: 7,
    category: ["otherThing"],
    title: "Kilarney Provincial Park",
    tech: "The Beautiful Canadian Shield of Northern Ontario ",
    img: "assets/kilarney_park.jpg",
  },
  {
    id: 8,
    category: ["otherThing"],
    title: "My first lego set",
    tech: "Legos",
    img: "assets/lego_set_346.jpg",
  },
];
